// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"aca15bdb","453":"3f4b9bd7","455":"96581c20","977":"b2bf17af"}[chunkId] + ".chunk.js";
};